<template>
    <div>

    <div  class="grid-container container">
      <div class="grid-x grid-padding-x">
        <div class="cell large-2">
          <!--Specific Selected Catalog-->
          <ul class="menu vertical product-catalog">
            <li class="menu-text text-uppercase">
              Profile
            </li>
            <li>
              <router-link :to="{name:'userProfile'}">
                Basic
              </router-link>
            </li>
            <!-- <li>
              <router-link :to="{name:'userSetting'}">
                Advanced
              </router-link>
            </li> -->
          </ul>
        </div>

        <div class="cell large-auto">
          <!--Search header-->
          <div class="grid-x callout primary radius" style="border: none;">
            <div class="cell large-6">
              <ul class="dropdown menu">
                <li class="menu-text">
                  <span style="font-weight: 300;"> Basic Settings</span>
                </li>
              </ul>
            </div>
          </div>

          <!--Right pannel-->
          <router-view />

        </div>
      </div>
    </div>

    <!--Space-->
    <div class="container"></div>
    </div>
</template>

<script>
    export default {
        name: 'main-view'
    }
</script>